<template>
  <section>
    <div class="login-container">
      <div class="logo-app"></div>
      <v-card class="login-form">
        <v-form
          @submit.prevent="submit"
          v-model="valid"
          ref="form"
          lazy-validation
        >
          <v-card-title class="headline">
            Plataforma de Pagos
            <v-btn icon @click.native="$store.commit('closeModal', 5)">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-alert
              outline
              color="info"
              icon="info"
              :value="true">
              Para poder registrar sus trámites debe ingresar su usuario y contraseña de la Plataforma de pagos de su entidad aquí.
            </v-alert>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    name="username"
                    :label="$t('login.user')"
                    id="username"
                    append-icon="person"
                    v-model="form.username"
                    autofocus
                    maxlength="25"
                    :rules="$validate(['required'])"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    name="password"
                    :label="$t('login.password')"
                    id="password"
                    append-icon="lock"
                    :append-icon="getIcon"
                    :append-icon-cb="changeIcon"
                    :type="hidePass ? 'password' : 'text'"
                    v-model="form.password"
                    maxlength="100"
                    :rules="$validate(['required'])"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              block
              large
              :disabled="!valid || loading"
              type="submit">
              <v-icon>verified_user</v-icon> {{ $t('login.login') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </div>
  </section>
</template>

<script>

import AppLang from '@/common/layout/AppLang';
import validate from '@/common/mixins/validate';

export default {
  mixins: [ validate ],
  data () {
    return {
      valid: true,
      form: {
        username: '',
        password: ''
      },
      hidePass: true,
      remember: false,
      loading: false
    };
  },
  methods: {
    changeIcon () {
      if (this.form.password.length) {
        this.hidePass = !this.hidePass;
      }
    },
    submit () {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$service.post(`eapostilla/login_ppte`, this.form)
        .then(response => {
          this.loading = false;
          if (response) { // resultado ok
            this.$message.success('Se ha establecido la conexión con la Plataforma de Pagos.');
            this.$store.commit('closeModal', 5);
            this.$store.commit('setAction', 'getDocumentos');
          }
        });
      }
    }
  },
  components: { AppLang },
  computed: {
    getIcon () {
      return this.form.password.length === 0 ? 'lock' : this.hidePass ? 'visibility' : 'visibility_off';
    }
  },
  watch: {
    'form.password': function (val) {
      if (val.length === 0) {
        this.hidePass = true;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// LoginPpte.vue?130abf80